import { SxProps } from '@mui/material'

interface PlaceAutocompleteStyles {
  dropdown: SxProps
  dropdownWrapperSx: SxProps
  list: SxProps
  listItem: SxProps
  listItemButton: SxProps
  name: SxProps
  location: SxProps
}

export const placeAutocompleteStyles: PlaceAutocompleteStyles = {
  dropdown: {
    p: 0,
  },
  dropdownWrapperSx: { zIndex: 'aboveDrawer' },
  list: {
    p: 0,
    maxHeight: 250,
    overflow: 'auto',
  },
  listItem: {
    p: 0,
    borderBottom: '1px solid',
    borderColor: 'button.borderSecondary',

    '&:last-child': {
      borderBottom: 'none',
    },
  },
  listItemButton: {
    px: 1.5,
    py: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  name: {
    typography: 'textSmMedium',
    color: 'text.secondary900',
  },
  location: {
    typography: 'textSm',
    color: 'text.secondary700',
  },
}
